// extracted by mini-css-extract-plugin
module.exports = {"arrow":"ChevronIcon_arrow__3m1cv","active":"ChevronIcon_active__2NV7n"};